import { FilterCriteria, RangeFilter } from '../../FilterStore'
import { FilterChipCloseButton, FilterChipContainer } from './FilterChipStyles'
import { useTableLinkVariant } from 'components/Tables/CommonTableCells/TableLinkStyleContext'

type FilterChipRangeProps = {
  title?: string
  value: RangeFilter
  onClose?: () => void
  filterCriteria: FilterCriteria
  isHovered?: boolean
}

export function FilterChipRange({
  title,
  value,
  onClose,
  filterCriteria,
  isHovered,
}: FilterChipRangeProps) {
  const { max, min } = value
  const isExclusive = filterCriteria === 'neither'
  const variant = useTableLinkVariant()
  const isPlain = variant === 'plain'

  const formatStrAsLocaleDate = (str: string) => {
    const date = new Date(str + 'T00:00:00')
    return date.toLocaleDateString()
  }

  const formatValue = (value: number | string) => {
    const isString = typeof value === 'string'
    const has3hyphens = value.toString().split('-').length === 3
    if (isString && has3hyphens) {
      return formatStrAsLocaleDate(value)
    }
    return value.toString()
  }

  const getFormattedValue = () => {
    if (min == null && max != null) return `≤ ${formatValue(max)}`
    if (max == null && min != null) return `≥ ${formatValue(min)}`

    return `${formatValue(min!)} - ${formatValue(max!)}`
  }

  return (
    <FilterChipContainer
      $isExclusive={isPlain ? false : isExclusive}
      isHovered={isHovered}
    >
      <span>
        {`${title}: `}
        {isPlain && isExclusive ? <b>NOT </b> : null}
        <b>{getFormattedValue()}</b>
      </span>
      {onClose && (
        <FilterChipCloseButton
          $isExclusive={isPlain ? false : isExclusive}
          onClick={onClose}
        />
      )}
    </FilterChipContainer>
  )
}
